import React from 'react';
import PropTypes from 'prop-types';

import RegistrationStepIndicator from '../../../../../components/RegistrationStepIndicator';
import { getPlayerName } from '../../../../../utils';
import { regStepIds, sidebarMessages } from '../../../../../utils/eventConstants';

import styles from './CustomSidebarStyles.scss';

const SidebarNavHeader = ({
    regStep,
    isPowerGateStep,
    isManagementGateStep,
    isPowerGateHeaderStep,
    isHybridGateStep,
    isHybridPowerFlow,
    showAnnualPowerStep,
    hybridGateTitleText,
    isAppleMonthlySubscriber,
    userIsAnnualPower,
    showBackArrow,
    onBackClick,
    onCloseClick,
    paymentProcessing,
    titleOverride,
    paymentTitle,
    claimedPlayer,
}) => {
    const processingTitle = paymentProcessing ? sidebarMessages.PAYMENT_PROCESSING : null;

    return (
        <nav className={`${styles.navbarCustomStyles} navbar navbar-light purple-grad ${isPowerGateHeaderStep ? 'power-gate-nav' : ''}`} data-testid="event-profile.sidebar.navbar">
            <div className="container" style={{ position: 'relative' }}>
                <div className="col d-flex justify-content-center align-items-center">
                    {showBackArrow && !isPowerGateHeaderStep && (
                        <div className="back-area" onClick={onBackClick} title={processingTitle}>
                            <i className="utr utr-prev" />
                        </div>
                    )}
                    {(isPowerGateStep || isManagementGateStep) ? (
                        <>
                            <RegistrationStepIndicator
                                showAnnualPowerStep={showAnnualPowerStep || isHybridPowerFlow}
                                isUpgradeStep={regStep.id === regStepIds.UPGRADE}
                                isCheckoutStep={regStep.id === regStepIds.PAYMENT || regStep.id === regStepIds.PAYMENT_WAIT}
                                hideSteps={isAppleMonthlySubscriber || isManagementGateStep}
                                hideTitle={userIsAnnualPower}
                                titleText={isHybridGateStep ? hybridGateTitleText : undefined}
                                onBack={showBackArrow && isPowerGateHeaderStep ? onBackClick : null}
                                backTitle={processingTitle}
                                data-testid="event-profile.sidebar.annual-power"
                                backTestId="event-profile.sidebar.annual-power-back-btn"
                                onClose={isPowerGateHeaderStep ? onCloseClick : null}
                                closeTestId="event-profile.sidebar.annual-power-close-btn"
                                closeIconTestId="event-profile.sidebar.annual-power-close-icon"
                            />
                            {!isPowerGateHeaderStep && (
                                <div className="close-area" style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer', zIndex: 2, padding: 8 }} onClick={onCloseClick} data-testid="event-profile.sidebar.annual-power-close-btn">
                                    <img className="close-icon" style={{ width: 16, height: 16 }} src="/img/icons/sidebar-close-icon.svg" data-testid="event-profile.sidebar.annual-power-close-icon" />
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <div>
                                <div className={`${styles.customTitle} text-highlight2 text-center`}>
                                    {titleOverride || paymentTitle || regStep.title}
                                </div>
                                <div className={`${styles.customSubTitle} text-center text-small`}>
                                    {claimedPlayer ? getPlayerName(claimedPlayer.firstName, claimedPlayer.lastName) : ''}
                                </div>
                                {!!regStep.subTitle && (
                                    <div className="text-center text-small">
                                        {regStep.subTitle}
                                    </div>
                                )}
                            </div>
                            <div className="close-area" onClick={onCloseClick} title={processingTitle} data-testid="event-profile.sidebar.close-btn">
                                <img className="close-icon" src="/img/icons/sidebar-close-icon.svg" data-testid="event-profile.sidebar.close-icon" />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </nav>
    );
};

SidebarNavHeader.propTypes = {
    regStep: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        subTitle: PropTypes.string,
    }).isRequired,
    isPowerGateStep: PropTypes.bool,
    isManagementGateStep: PropTypes.bool,
    isPowerGateHeaderStep: PropTypes.bool,
    isHybridGateStep: PropTypes.bool,
    isHybridPowerFlow: PropTypes.bool,
    showAnnualPowerStep: PropTypes.bool,
    hybridGateTitleText: PropTypes.string,
    isAppleMonthlySubscriber: PropTypes.bool,
    userIsAnnualPower: PropTypes.bool,
    showBackArrow: PropTypes.bool,
    onBackClick: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    paymentProcessing: PropTypes.bool,
    titleOverride: PropTypes.string,
    paymentTitle: PropTypes.string,
    claimedPlayer: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    }),
};

SidebarNavHeader.defaultProps = {
    isPowerGateStep: false,
    isManagementGateStep: false,
    isPowerGateHeaderStep: false,
    isHybridGateStep: false,
    isHybridPowerFlow: false,
    showAnnualPowerStep: false,
    hybridGateTitleText: null,
    isAppleMonthlySubscriber: false,
    userIsAnnualPower: false,
    showBackArrow: false,
    paymentProcessing: false,
    titleOverride: null,
    paymentTitle: null,
    claimedPlayer: null,
};

export default SidebarNavHeader;
